<div class="container">
  <div class="content">
      <div class='row'>
      <div class="editor col-10">
        <textarea [readOnly]="!canAddComment()" fieldSize="large" [placeholder]="'pages.workflow.comments.add-comment-placeholder' | translate" fullWidth nbInput type="text" [mention]="mentions()" [mentionConfig]="mentionConfig" #content></textarea>
      </div>
      <button [disabled]="!canAddComment()" nbButton (click)='onSubmit(content)' class='col-2 mb-1' status="basic">
        {{'Send' | translate}}
        <nb-icon icon="paper-plane-outline"></nb-icon>
      </button>
      </div>
    <!-- </form> -->
  </div>
</div>
